export { CampaignOptType } from './generated/CampaignOptType.js';